import { LuExternalLink, LuMapPin } from "react-icons/lu";
import RichText from "./RichText";

// Un puesto de experiencia laboral.
// Props: company, companyUrl (opcional), role, employmentType (opcional, el
//        "turno": Tiempo completo / Freelance / …), period, location (opcional),
//        bullets[].
// Cuando companyUrl tiene valor, la empresa se muestra como enlace clicable
// (misma tipografía/color) que abre en pestaña nueva; si no, como texto.
// `location` es opcional: si viene, se muestra bajo la fecha con un pin discreto.
export default function ExperienceItem({
  company,
  companyUrl,
  role,
  employmentType,
  period,
  location,
  bullets = [],
}) {
  const hasUrl = Boolean(companyUrl && companyUrl.trim());
  const hasLocation = Boolean(location && location.trim());
  const hasType = Boolean(employmentType && employmentType.trim());

  return (
    <article className="cv-exp">
      <div className="cv-exp-head">
        <p className="cv-exp-heading">
          {hasUrl ? (
            <a
              className="cv-company cv-company-link"
              href={companyUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visitar sitio web de ${company}`}
            >
              {company}
              <LuExternalLink className="cv-company-ext" aria-hidden="true" size={11} />
            </a>
          ) : (
            <span className="cv-company">{company}</span>
          )}
          <span className="cv-exp-sep"> — </span>
          <span className="cv-exp-role">{role}</span>
          {hasType ? <span className="cv-exp-type"> · {employmentType}</span> : null}
        </p>
        {(period || hasLocation) && (
          <span className="cv-exp-meta">
            {period ? <span className="cv-period">{period}</span> : null}
            {hasLocation ? (
              <span className="cv-location">
                <LuMapPin className="cv-location-icon" aria-hidden="true" size={10} />
                {location}
              </span>
            ) : null}
          </span>
        )}
      </div>
      {bullets.length > 0 && (
        <ul className="cv-bullets">
          {bullets.map((b, i) => (
            <li key={i}>
              <RichText text={b} />
            </li>
          ))}
        </ul>
      )}
    </article>
  );
}
